export const parseHtmlContent = (
  htmlString,
  {
    classNameB = '',
    classNameSpan = '',
    classNameLink = '',
    imgClassName = '',
    imgDefaultProps = {}
  } = {}
) => {
  // Создаем временный div для парсинга HTML
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlString

  // Преобразует строку стилей в объект для React
  const parseStyleString = (styleString) => {
    if (!styleString) return {}
    const styles = {}
    styleString.split(';').forEach((rule) => {
      if (!rule.trim()) return
      const [key, value] = rule.split(':').map((s) => s.trim())
      if (key && value) {
        // Конвертируем дефисы в заглавные буквы
        const camelCaseKey = key.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
        styles[camelCaseKey] = value
      }
    })
    return styles
  }

  // Конвертируем HTML в React элементы
  const convertNodeToReact = (node, index = 0) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const tagName = node.tagName.toLowerCase()
      const children = Array.from(node.childNodes).map((child, i) => convertNodeToReact(child, i))

      switch (tagName) {
        case 'b':
          return (
            <b key={index} className={classNameB}>
              {children}
            </b>
          )
        case 'strong':
          return <strong key={index}>{children}</strong>
        case 'br':
          return <br key={index} />
        case 'span':
          return (
            <span key={index} className={classNameSpan}>
              {children}
            </span>
          )
        case 'em':
          return <em key={index}>{children}</em>
        case 'a':
          return (
            <a
              key={index}
              target="_blank"
              rel="noopener noreferrer"
              className={classNameLink}
              href={node.getAttribute('href')}
            >
              {children}
            </a>
          )
        case 'img':
          return (
            <img
              key={index}
              src={node.getAttribute('src')}
              alt={node.getAttribute('alt') || ''}
              className={imgClassName}
              {...imgDefaultProps}
              width={node.getAttribute('width')}
              height={node.getAttribute('height')}
              style={parseStyleString(node.getAttribute('style'))}
              loading="lazy"
            />
          )
        default:
          return <p key={index}>{children}</p>
      }
    }

    return null
  }

  return Array.from(tempDiv.childNodes).map((node, index) => convertNodeToReact(node, index))
}
